import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './shared/language/services/language.service';

@Component({
  selector: 'pozi-root',
  imports: [RouterOutlet],
  template: '<router-outlet/>',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private languageService = inject(LanguageService);

  ngOnInit(): void {
    this.languageService.switchToLanguageFromCookie();
  }
}
